import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=488c6f59&scoped=true&"
import script from "./LeftNav.vue?vue&type=script&lang=js&"
export * from "./LeftNav.vue?vue&type=script&lang=js&"
import style0 from "./LeftNav.vue?vue&type=style&index=0&id=488c6f59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c6f59",
  null
  
)

export default component.exports